import { BaseController } from "./baseController";
import { 
    type CredentialResponse, 
    type InsuranceResponse 
} from "components/ProviderProfile/interfaces";
import { 
    type LiabilityInsurancePayload, 
    type LicensePayload 
} from "../types";

export interface AverageSessionsPayload {
    fromDate: string;
    toDate: string;
    providerId: number;
}

export class CredentialsController extends BaseController {
    constructor(apiHost: string, version = 'v1') {
        super(apiHost, version);
        this.setHeaders({ 'Content-Type': 'multipart/form-data' });
    }

    // Credentials endpoints
    async addCredential(payload: LicensePayload, version = this.version): Promise<CredentialResponse> {
        return this.post<CredentialResponse, LicensePayload>(this.getEndpoint('credentials', version), payload);
    }

    async updateCredential(payload: LicensePayload, version = this.version): Promise<CredentialResponse> {
        return this.patch<CredentialResponse, LicensePayload>(this.getEndpoint(`credentials/${payload.providerLicenseId}`, version), payload);
    }

    async deleteCredential(id: string, version = this.version): Promise<void> {
        await this.delete<void>(this.getEndpoint(`credentials/${id}`, version));
    }

    async replaceCredential(payload: LicensePayload, version = this.version): Promise<CredentialResponse> {
        return this.put<CredentialResponse, LicensePayload>(this.getEndpoint(`credentials/${payload.providerLicenseId}`, version), payload);
    }

    // Insurance endpoints
    async addInsurance(payload: LiabilityInsurancePayload, version = this.version): Promise<InsuranceResponse> {
        return this.post<InsuranceResponse, LiabilityInsurancePayload>(this.getEndpoint('insurance', version), payload);
    }

    async updateInsurance(payload: LiabilityInsurancePayload, version = this.version): Promise<InsuranceResponse> {
        return this.patch<InsuranceResponse, LiabilityInsurancePayload>(this.getEndpoint(`insurance/${payload.providerId}`, version), payload);
    }

    async deleteInsurance(providerId: string, version = this.version): Promise<void> {
        await this.delete<void>(this.getEndpoint(`insurance/${providerId}`, version));
    }

    async replaceInsurance(payload: LiabilityInsurancePayload, version = this.version): Promise<InsuranceResponse> {
        return this.put<InsuranceResponse, LiabilityInsurancePayload>(this.getEndpoint(`insurance/${payload.providerId}`, version), payload);
    }

    async fetchAverageCompletedSessions(params: AverageSessionsPayload, version = this.version): Promise<string> {
        const response = await this.get<string, AverageSessionsPayload>(
            this.getEndpoint(`Provider/AverageCompletedSessions/${params.providerId}`, version),
            params,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response;
    }
}
